import React, { useState } from "react";
import { Plus, ArrowLeft} from "react-bootstrap-icons";

import AddItemButton from 'components/Buttons/AddItemButton';
import List from "components/Values/List"

import "./styles.css";

function ListView({
    items = [],
    onClickHandler,
    onDeleteHandler,
    onEditHandler,
    onBackClick,
    setCurrentState
}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    return (
        <div className="card card-paddings container-height">

            <div className="card-header card-header-paddings no-background no-border">
                <div className="p-2">
                    <h3>Values</h3>
                    <span>Create values to keep support information that could be used for statistics</span>
                </div>
            </div>

            <div className="card-body overflow-auto p-0">

                {items.length > 0 ? (
                    <List 
                        items={items}
                        // onClickHandler={onClickHandler}
                        onEditHandler={onEditHandler}
                        onDeleteHandler={onDeleteHandler}
                    />
                ) : !isMobile ? (
                    <div
                        className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
                        onClick={() => setCurrentState('add')}
                        style={{ cursor: "pointer" }}
                    >
                        <Plus size={80} className="text-primary" />
                        <p className="text-muted mt-3">Click to add your first value</p>
                    </div>
                ) : (
                    <></>
                )}

            </div>

            {isMobile && (
                <div className="card-footer card-footer-paddings border-top no-background">

                    <div className="d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => setCurrentState('add')}
                        >
                            Add
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary ms-auto"
                            onClick={(e) => {
                                e.preventDefault();

                                onBackClick();
                            }}
                        >
                            <ArrowLeft className="me-2" />
                            Back
                        </button>
                    </div>
                </div>
            )}


            {!isMobile && items.length > 0 && (
                <div
                    className="card-footer card-footer-paddings no-border no-background mt-auto"
                >
                    <AddItemButton onClick={() => setCurrentState('add')} />
                </div>
            )}

        </div>
    );
};

export default ListView;